import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function RegisterCustomer() {
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", mobile: "", password: "" });
  const [loading, setLoading] = useState(false);
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register/customer", f);
      toast.success("أرسلنا رمز تفعيل إلى بريدك الإلكتروني");
      nav("/verify-email", { state: { email: data.email, role: data.role } });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-14">
      <h1 className="font-head text-2xl font-black text-white text-center mb-2">إنشاء حساب عميل</h1>
      <p className="text-sm text-[var(--text-muted)] text-center mb-8">ابحث واطلب قطع غيار سيارتك بسهولة</p>
      <form onSubmit={submit} className="ts-card p-6 space-y-4">
        <Field label="الاسم" testid="reg-name" value={f.name} onChange={up("name")} required />
        <Field label="البريد الإلكتروني" testid="reg-email" type="email" value={f.email} onChange={up("email")} required />
        <Field label="رقم الجوال" testid="reg-mobile" value={f.mobile} onChange={up("mobile")} placeholder="05xxxxxxxx" required />
        <Field label="كلمة المرور" testid="reg-password" type="password" value={f.password} onChange={up("password")} required />
        <button data-testid="register-submit" disabled={loading} className="btn-amber w-full justify-center disabled:opacity-60">
          {loading ? "جارٍ الإنشاء..." : "إنشاء الحساب"}
        </button>
        <div className="flex items-center gap-3 py-1">
          <span className="h-px flex-1 bg-[var(--border-c)]" />
          <span className="text-xs text-[var(--text-subtle)]">أو</span>
          <span className="h-px flex-1 bg-[var(--border-c)]" />
        </div>
        <button type="button" onClick={googleLogin} data-testid="register-google" className="w-full flex items-center justify-center gap-2 rounded-xl border border-[var(--border-c)] py-3 text-sm font-bold text-white hover:border-[var(--amber)] transition-colors">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22 22-9.8 22-22c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 18.9 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 15.4 2 8 6.9 4.3 14z"/><path fill="#4CAF50" d="M24 46c5.5 0 10.5-2.1 14.3-5.5l-6.6-5.6C29.6 36.6 26.9 38 24 38c-5.2 0-9.6-3.3-11.3-7.9l-6.6 5.1C9.6 41 16.2 46 24 46z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.6l6.6 5.6C41.4 36.6 46 31 46 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
          التسجيل عبر Google
        </button>
      </form>
      <p className="text-center text-sm text-[var(--text-muted)] mt-6">لديك حساب؟ <Link to="/login" className="text-[var(--amber)] font-bold">سجّل الدخول</Link></p>
    </div>
  );
}

export function Field({ label, testid, type = "text", ...rest }) {
  return (
    <div>
      <label className="text-xs font-bold text-[var(--text-muted)] block mb-1.5">{label}</label>
      <input data-testid={testid} type={type} {...rest}
        className="w-full rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none" />
    </div>
  );
}
